import { colors, Subtitle1, Body1 } from 'ui/theme';
import { GoalDetailsPanel } from './GoalDetailsPanel';
import { InProgressStatusProps } from '../types';
import {
  TEST_IDS,
  USER_PROFILE_FIELD,
  BUILDING_PRD_GOAL,
  IN_PROGRESS_STATUS,
  WHEN_READY,
  CREATE_SEGMENT,
  VIEW_THE,
  SCORE_ON_USERS,
  VIEW_GOAL_DETAILS,
} from '../constants';
import {
  GoalDetailInnerCard,
  LayoutWithPanel,
  MainContentLayout,
  MainLayoutWrapper,
  StatusParagraph,
  StyledArrowRightCircle,
  StyledMonospace,
  Title,
} from './Styled';
import { StatusPageGoalCriteria } from './StatusPageGoalCriteria';
import { GoalDetailsPredictionSection } from './GoalDetailsPredictionSection';

export const InProgressStatus = ({ goal }: InProgressStatusProps) => {
  return (
    <MainLayoutWrapper
      data-background-color={colors.backgroundSecondary}
      data-testid={TEST_IDS.PreparingPage}
    >
      <LayoutWithPanel>
        <GoalDetailsPanel showOnlyCoreDetails goal={goal} />
        <MainContentLayout>
          <StatusPageGoalCriteria goal={goal} />
          <GoalDetailsPredictionSection>
            <Title>{BUILDING_PRD_GOAL}</Title>
            <StatusParagraph>{IN_PROGRESS_STATUS}</StatusParagraph>
            <GoalDetailInnerCard>
              <Subtitle1>{WHEN_READY}</Subtitle1>
              <StatusParagraph>
                <Body1>
                  <StyledArrowRightCircle />
                  {CREATE_SEGMENT}
                  <StyledMonospace>{goal.userProfileField}</StyledMonospace>{' '}
                  {`${USER_PROFILE_FIELD.toLowerCase()}.`}
                </Body1>
              </StatusParagraph>
              <StatusParagraph>
                <Body1>
                  <StyledArrowRightCircle />
                  {`${VIEW_THE} `}
                  <StyledMonospace>{goal.userProfileField}</StyledMonospace>
                  {` ${SCORE_ON_USERS}`}
                </Body1>
              </StatusParagraph>
              <StatusParagraph>
                <Body1>
                  <StyledArrowRightCircle />
                  {VIEW_GOAL_DETAILS}
                </Body1>
              </StatusParagraph>
            </GoalDetailInnerCard>
          </GoalDetailsPredictionSection>
        </MainContentLayout>
      </LayoutWithPanel>
    </MainLayoutWrapper>
  );
};
